import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-letter-pad',
  templateUrl: './letter-pad.component.html',
  styleUrls: ['./letter-pad.component.css']
})
export class LetterPadComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
